import { useTranslation } from 'react-i18next'

import { CoinsIcon } from '@phosphor-icons/react'

import { ButtonWithSpinner, CardTitle, Divider, Drawer } from '@reveni-io/reveni-ui'

import RefundMethodSelector from '@/returns/components/RefundMethodSelector/RefundMethodSelector'
import RefundNotes from '@/returns/components/RefundNotes/RefundNotes'
import RefundSummary from '@/returns/components/RefundSummary/RefundSummary'
import TotalRefundAmount from '@/returns/components/TotalRefundAmount/TotalRefundAmount'

import { getRefundMethodExtraLabel } from '../helpers'
import useIssueRefundForm from './useIssueRefundForm/useIssueRefundForm'
import * as Styles from './styles'

const IssueRefundDrawer = ({ show, transaction, returnId, onClose, onIssued, onError, allowsEditRefundMethod }) => {
  const { t } = useTranslation()

  const {
    refundMethod,
    setRefundMethod,
    note,
    setNote,
    availableRefundMethods,
    selectedConcepts,
    refundMethodExtraAmount,
    showExtra,
    isFormValid,
    isIssueRefundLoading,
    onCancel,
    onAccept,
  } = useIssueRefundForm({ show, transaction, returnId, onClose, onIssued, onError })

  return (
    <Drawer show={show} onClose={onCancel} options={{ showHeaderActions: false }}>
      <CardTitle Icon={CoinsIcon}>{t('Editar resultado transacción')}</CardTitle>
      <Styles.Container>
        <RefundSummary
          currency={transaction?.summary?.currency}
          selectedConcepts={selectedConcepts}
          extraAmount={refundMethodExtraAmount}
          extraLabel={getRefundMethodExtraLabel(refundMethod, t)}
          showExtra={showExtra}
        />
        <Divider />
        <TotalRefundAmount
          currency={transaction?.summary?.currency}
          selectedConcepts={selectedConcepts}
          extraAmount={refundMethodExtraAmount}
          showExtra={showExtra}
        />
        <RefundMethodSelector
          refundMethods={availableRefundMethods}
          refundMethodSelected={refundMethod}
          onChange={setRefundMethod}
          disabled={!allowsEditRefundMethod}
        />
        <Divider />
        <RefundNotes value={note} onChange={setNote} />
        <Styles.Actions>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Emitir reembolso')}
            loadingLabel={t('Emitir reembolso')}
            loading={isIssueRefundLoading}
            disabled={!isFormValid() || isIssueRefundLoading}
            onClick={onAccept}
          />
          <ButtonWithSpinner fullWidth variant="outlined" defaultLabel={t('Cancelar')} onClick={onCancel} />
        </Styles.Actions>
      </Styles.Container>
    </Drawer>
  )
}

export default IssueRefundDrawer
